// import external dependencies
import * as overlay from '../interactive3d/overlay';
import * as scene from '../interactive3d/scene';

export function init(container) {
  const renderer = scene.setup(container);
  container.appendChild(renderer.domElement);

  overlay.setup(container.getElementsByClassName('interactive-3d__overlay')[0]);
  const links = overlay.elements.navigation.children('a');
  links.on('click', changeSlide);
  const next = overlay.elements.slides.children('a.js-change-slide');
  next.on('click', changeSlide);

  const intro = links[0];
  if(intro && intro.dataset.slide) {
    const slide = overlay.changeSlide(intro.dataset.slide);
    scene.changeScene(slide.dataset.threeAsset);
  }
}

export function changeSlide(evt) {
  evt.preventDefault();
  evt.stopPropagation();

  const target = evt.target;
  const slide = overlay.changeSlide(target.dataset.slide);
  let camera = 0;
  // switch (target.dataset.slide)

  scene.changeScene(slide.dataset.threeAsset, camera);
}
